export class TbaParameter {
  tbaParameterId: number;
  type: string;
  description: string;
  optional: boolean;
}
